<script setup lang="ts">
import UserForgotPasswordView from 'src/modules/User/views/UserForgotPasswordView/UserForgotPasswordView.vue';
import { useQuasar } from 'quasar';
import UserAuthPageDecoration from 'src/shared/components/UserAuthPageDecoration/UserAuthPageDecoration.vue';

const $q = useQuasar();
$q.dark.set(true);
</script>

<template>
  <q-page
    padding
    class="column bg-dark"
  >
    <UserForgotPasswordView
      class="column fit items-center justify-center relative"
    />
    <UserAuthPageDecoration />
  </q-page>
</template>
